import Api from "../../Api"
import Request from "services/constants/Request.api"

class PlasticsDG extends Api {
  constructor(user) {
    super()
    this.user = user
  }
  getSubmittedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/submitted/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getHoDReviewDetails = data => {
    const request = new Request({
      data: {
        url: "application/hod-review?application_id=" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDepartmentApprovedApplications = page => {
    const request = new Request({
      data: {
        url: "applications/department/department-approved" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAllApprovedApplications = page => {
    const request = new Request({
      data: {
        url: "applications/approved/all" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAllRejectedApplications = page => {
    const request = new Request({
      data: {
        url: "applications/rejected/all" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  reviewApplication = data => {
    const request = new Request({
      data: {
        reason: data.reason,
        decision_code: data.decision_code,
        application_id: data.application_id,
        url: "staff/application/dg/review/" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }
}

export default PlasticsDG
